export default __webpack_public_path__ + "static/media/404-illustration.ee4d58f7.svg";